import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

export const onboardingFeatureKey = 'onboarding';

export type OnboardingType = 'customer' | 'invitation'; // NEW: Define OnboardingType

import { IOnboardingFormData } from './onboarding.dto';
import { ICheckTokenResponse } from './onboarding.responses.dto';

export const onboardingSubmit = createAction(
  `[${onboardingFeatureKey}] Onboarding Submit`,
  props<{ formData: IOnboardingFormData, token: string }>()
);

export const onboardingInvitedSubmit = createAction(
  `[${onboardingFeatureKey}] Invited onboarding Submit`,
  props<{ formData: IOnboardingFormData, apiUrl: string }>()
);

export const onboardingSubmitSucceeded = createAction(
  `[${onboardingFeatureKey}] Onboarding Submit Succeeded`,
  props<{ response: any }>()
);

export const onboardingSubmitFailed = createAction(
  `[${onboardingFeatureKey}] Onboarding Submit Failed`,
  props<{ error: HttpErrorResponse }>()
);

export const resetOnboardingState = createAction(
  `[${onboardingFeatureKey}] Reset Onboarding State`
);

export const updateUserProfileField = createAction(
  `[${onboardingFeatureKey}] Update User Profile Field`,
  props<{ field: string, value: any }>()
);

export const updateProfileImage = createAction(
  `[${onboardingFeatureKey}] Update Profile Image`,
  props<{ profileImage: string | null }>()
);

export const togglePasswordTextType = createAction(
  `[${onboardingFeatureKey}] Toggle Password Text Type`
);

export const setUserProfileFormSubmitted = createAction(
  `[${onboardingFeatureKey}] Set User Profile Form Submitted`,
  props<{ submitted: boolean }>()
);

export const setProfileImageFile = createAction(
  `[${onboardingFeatureKey}] Set Profile Image File`,
  props<{ profileImageFile: File | null }>()
);

export const updateTellUsAboutYouWorkType = createAction(
  `[${onboardingFeatureKey}] Update Tell Us About You Work Type`,
  props<{ workType: string }>()
);

export const updateHowPlanToUsePlanningToUse = createAction(
  `[${onboardingFeatureKey}] Update How Plan To Use Planning To Use`,
  props<{ planningToUse: string }>()
);

export const resetLayoutConfig = createAction(
  `[${onboardingFeatureKey}] Reset Layout Config`
);

export const setOnboardingType = createAction(
  `[${onboardingFeatureKey}] Set Onboarding Type`,
  props<{ onboardingType: OnboardingType }>()
);

export const checkToken = createAction(
  `[${onboardingFeatureKey}] Check Token`,
  props<{ token: string }>()
);

export const checkTokenSuccess = createAction(
  `[${onboardingFeatureKey}] Check Token Success`,
  props<{ response: ICheckTokenResponse }>()
);

export const checkTokenFailure = createAction(
  `[${onboardingFeatureKey}] Check Token Failure`,
  props<{ error: HttpErrorResponse }>()
);

export const setProfileStepSkipped = createAction(
  `[${onboardingFeatureKey}] Set Profile Step Skipped`,
  props<{ skipped: boolean }>()
);

export const updateError = createAction(
  `[${onboardingFeatureKey}] Update Error`,
  props<{ error: string }>()
);